import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAppMode } from '@/shared/utils';
import { useBackAction } from './useBackAction';
import { useOpenLayersCount } from './useCloseOnBack';

/** Корневые вкладки: «назад» здесь закрывает мини-приложение, как и должно */
const ROOT_PATHS = new Set([
  '/',
  '/home',
  '/catalog',
  '/prescriptions',
  '/cart',
  '/profile',
]);

/**
 * Кнопка «назад» MAX на Android. Системный жест и кнопка «назад» уходят
 * в MAX раньше страницы, и без этой кнопки MAX закрывает мини-приложение.
 * На iOS не включаем: там работает свайп от края (useSwipeBack), а кнопка
 * в шапке MAX задвоила бы нашу стрелку.
 */
export function useMaxBackButton() {
  const { pathname } = useLocation();
  const onBack = useBackAction();
  const openLayers = useOpenLayersCount();

  const backButton =
    getAppMode() === 'max' && window.WebApp?.platform === 'android'
      ? window.WebApp.BackButton
      : undefined;

  // Первый выбор региона — истории нет, уходить некуда
  const historyIndex =
    (window.history.state as { idx?: number } | null)?.idx ?? 0;
  const isFirstRegionPick = pathname === '/region' && historyIndex === 0;

  const isVisible =
    openLayers > 0 || (!ROOT_PATHS.has(pathname) && !isFirstRegionPick);

  useEffect(() => {
    if (!backButton) return;

    if (isVisible) backButton.show();
    else backButton.hide();
  }, [backButton, isVisible]);

  useEffect(() => {
    if (!backButton) return;

    backButton.onClick(onBack);
    return () => backButton.offClick(onBack);
  }, [backButton, onBack]);
}
